import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import extractText from 'flarum/common/utils/extractText';
// import m from 'mithril';

export default class CustomFooter extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.value = '';
    this.loading = false;
    this.success = true;
    this.showTip = true;
    this.tipText = '';
    this.subEmail = '';
    this.mainDomains = {
      de: 'dvdfab.at',
      en: 'www.dvdfab.cn',
      fr: 'dvdfab.fr',
      ja: 'dvdfab.org',
      'zh-Hant': 'dvdfab.tw',
    };
    this.subscribeError1 = extractText(app.translator.trans('dvdfab-footer.forum.footer.subscribeError1'));
    this.subscribeError2 = extractText(app.translator.trans('dvdfab-footer.forum.footer.subscribeError2'));
    this.subscribeError3 = extractText(app.translator.trans('dvdfab-footer.forum.footer.subscribeError3'));
    this.subscribeError4 = extractText(app.translator.trans('dvdfab-footer.forum.footer.subscribeError4'));
  }

  // 订阅新闻信
  handleEmailChange = (e) => {
    this.subEmail = e.target.value;
  };

  clickSub = () => {
    // this.loading = true;
    this.tipText = '';
    this.showTip = false;
    // 触发重新渲染
    // m.redraw();
    const currentLocale = app.data.locale;
    const params = {
      lang: currentLocale === 'zh-Hant' ? 'zh' : currentLocale,
      locale: currentLocale === 'zh-Hant' ? 'zh' : currentLocale,
      laravel_session: '',
      email: this.subEmail,
      check_url: `https://${this.mainDomains[currentLocale]}/newsletter.htm?a=subscribe&t=check&h=`,
    };
    if (this.validateForm(this.subEmail)) {
      // app
      //   .request({
      //     method: 'POST',
      //     url: app.forum.attribute('phpApiDomain') + '/news_letter/subscribe/per',
      //     body: params,
      //     headers: {}
      //   })
      fetch(app.forum.attribute('phpApis')[currentLocale] + '/news_letter/subscribe/per', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(r => r.json())
        .then((res) => {
          if (res.cscode === 0) {
            this.success = true;
            this.showTip = true;
            // 订阅成功
            this.tipText = this.subscribeError4;
            // 触发重新渲染
            m.redraw();
            setTimeout(() => {
              this.success = false;
              this.showTip = false;
              this.subEmail = '';
              this.tipText = '';
              m.redraw();
            }, 3000);
          } else {
            this.success = false;
            this.showTip = true;
            // 订阅失败
            this.tipText = this.subscribeError3;
          }
          // m.redraw();
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e);
          this.success = false;
          this.showTip = true;
          this.tipText = this.subscribeError3;
          // m.redraw();
        });
    }
  };

  // 校验邮箱
  validateForm = (value) => {
    // eslint-disable-next-line no-useless-escape
    const emailReg = /^([A-Za-z0-9_\+\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (value === '') {
      this.showTip = true;
      // 不能为空
      this.tipText = this.subscribeError2;
      return false;
    } else if (!emailReg.test(value)) {
      this.showTip = true;
      // 邮箱格式不正确
      this.tipText = this.subscribeError1;
      return false;
    }
    return true;
  };

  view() {
    return (
      <footer class="dvdfab-footer">
        <div class="menu-box container">
          <section class="menu-left">
            <ul>
              <li class="menu-item-title">
                <span>{app.translator.trans('dvdfab-footer.forum.footer.products_services')}</span>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.download_center_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.download_center')}
                </a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.shop_url')}>{app.translator.trans('dvdfab-footer.forum.footer.shop')}</a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.fab365_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.fab365')}
                </a>
              </li>
            </ul>
            <ul>
              <li class="menu-item-title">
                <span>{app.translator.trans('dvdfab-footer.forum.footer.support_resources')}</span>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.support_center_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.support_center')}
                </a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.resources_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.resources')}
                </a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.forum_url')}>{app.translator.trans('dvdfab-footer.forum.footer.forum')}</a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.blog_url')}>{app.translator.trans('dvdfab-footer.forum.footer.blog')}</a>
              </li>
            </ul>
            <ul>
              <li class="menu-item-title">
                <span>{app.translator.trans('dvdfab-footer.forum.footer.about_us')}</span>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.about_dvdfab_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.about_dvdfab')}
                </a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.editorial_team_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.editorial_team')}
                </a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.company_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.company')}
                </a>
              </li>
              <li>
                <a href={app.translator.trans('dvdfab-footer.forum.footer.affiliate_program_url')}>
                  {app.translator.trans('dvdfab-footer.forum.footer.affiliate_program')}
                </a>
              </li>
            </ul>
          </section>
          <section class="menu-right">
            <span class="menu-item-title">{app.translator.trans('dvdfab-footer.forum.footer.subscribe_newsletter')}</span>
            <p>{app.translator.trans('dvdfab-footer.forum.footer.subscribe_description')}</p>
            <div class="subscribe-box">
              <input
                id="subValue"
                value={this.subEmail}
                type="text"
                placeholder={app.translator.trans('dvdfab-footer.forum.footer.email_placeholder')}
                oninput={this.handleEmailChange}
              />
              <div class="my-btn" onclick={this.clickSub}>
                <div>{app.translator.trans('dvdfab-footer.forum.footer.send_button')}</div>
              </div>
              {this.showTip && <div className={`email-err ${this.success ? 'email-success' : ''}`}>{this.tipText}</div>}
            </div>
          </section>
        </div>
        <div class="container footer-bottom">
          <div>
            <hr class="split-line" />
            <div>
              <section class="footer-bottom-content">
                <a href={app.translator.trans('dvdfab-footer.forum.footer.log_url')} class="footer-logo">
                  <img
                    onerror="this.setAttribute('data-error', 1)"
                    width="112"
                    height="36"
                    alt="dvdfab logo"
                    loading="lazy"
                    srcset="https://images.dvdfab.cn/media/logo_2x_93bce04015.png/public 1x"
                    imgpreload="false"
                    src="https://images.dvdfab.cn/media/logo_2x_93bce04015.png/public"
                  />
                </a>
                <ul class="protocol-list">
                  <li>
                    <a href={app.translator.trans('dvdfab-footer.forum.footer.statement_url')} target="_blank">
                      {app.translator.trans('dvdfab-footer.forum.footer.statement')}
                    </a>
                  </li>
                  <li>
                    <a href={app.translator.trans('dvdfab-footer.forum.footer.terms_of_use_url')} target="_blank">
                      {app.translator.trans('dvdfab-footer.forum.footer.terms_of_use')}
                    </a>
                  </li>
                  <li>
                    <a href={app.translator.trans('dvdfab-footer.forum.footer.privacy_policy_url')} target="_blank">
                      {app.translator.trans('dvdfab-footer.forum.footer.privacy_policy')}
                    </a>
                  </li>
                  <li>
                    <a href={app.translator.trans('dvdfab-footer.forum.footer.purchase_policy_url')} target="_blank">
                      {app.translator.trans('dvdfab-footer.forum.footer.purchase_policy')}
                    </a>
                  </li>
                  <li>
                    <a href={app.translator.trans('dvdfab-footer.forum.footer.refund_policy_url')} target="_blank">
                      {app.translator.trans('dvdfab-footer.forum.footer.refund_policy')}
                    </a>
                  </li>
                  <li>
                    <a href={app.translator.trans('dvdfab-footer.forum.footer.cookies_policy_url')} target="_blank">
                      {app.translator.trans('dvdfab-footer.forum.footer.cookies_policy')}
                    </a>
                  </li>
                  <li>
                    <a href={app.translator.trans('dvdfab-footer.forum.footer.sitemap_url')} target="_blank">
                      {app.translator.trans('dvdfab-footer.forum.footer.sitemap')}
                    </a>
                  </li>
                </ul>
              </section>
            </div>
            <p class="copyright">{app.translator.trans('dvdfab-footer.forum.footer.copyright')}</p>
            <p class="disclaimer">{app.translator.trans('dvdfab-footer.forum.footer.disclaimer')}</p>
          </div>
        </div>
      </footer>
    );
  }
}
